import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { PhotoService } from '../../../../../app/shared/API-Service/services/photo.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Image } from '../../../../../images/images'



@Component({
  selector: 'app-view-photo',
  templateUrl: './view-photo.component.html',
  styleUrls: ['./view-photo.component.css']
})
export class ViewPhotoComponent implements OnInit {
  photoes:object [] = [];
  img : string = Image;
  constructor(private _PhotoService:PhotoService,private _Router:Router) { }

  ngOnInit(): void {
    this.getphoto();
  }
  getphoto(){
    this._PhotoService.Getphoto().subscribe((res) => {
      this.photoes = res.data
    console.log(this.photoes);
    
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }
  update(data){
    this._PhotoService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertPhoto']);
    }
    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._PhotoService.Deletephoto(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getphoto();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
            console.log("completed");
          })
        }
      }) 
    }
}
